<template>
  <div class="inviter-order-lists">
    <div class="common-header-wrap">
      <mt-header title="推广详情" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
      <p class="m-title">+{{baseinfo.orderinviter_money}}</p>
      <p class="fxsp">分销商品：</p>
      <div class="inviters-item">
      
         <div class="item-left">
           <img :src="baseinfo.orderinviter_goods_image" alt="">
         </div>
         <div class="item-right">
          <div class="ellipsi">{{baseinfo.orderinviter_goods_name}}</div>
           <p class="f-s"><span style="color:red;">状态:{{baseinfo.orderinviter_order_remark}} </span><span> {{baseinfo.orderinviter_addtime}}</span></p>
           <p>订单编号:{{baseinfo.orderinviter_order_sn}}</p>
         </div>
      </div>
      <p class="fxgx" >分销关系：</p>
      <p class="fxgx">{{baseinfo.orderinviter_remark}}</p>

  </div>
</template>

<script>
import { getInviterOrderdetail } from '../../../api/memberInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'MemberInviterDetail',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      orderList: false,
      baseinfo:{}
    }
  },
  created () {

  },

  mounted () {
     this.getOrderList(this.$route.query.orderinviter_id)
  },
  methods: {
    getOrderList (id) {
      Indicator.open()
      getInviterOrderdetail(id).then(res => {
        Indicator.close()
        if (res) {
           console.log(res)
           this.baseinfo = res.result
        }
      })
    },
    // loadMore () {
    //   this.loading = true
    //   this.params.page = ++this.params.page
    //   if (this.isMore) {
    //     this.loading = false
    //     this.getOrderList(true)
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
  .inviter-order-lists {}
  .inviter-order-lists .inviter-item {  background-color: #FFF;position: relative; z-index: 1; display: block; padding: 0.5rem 0; border-bottom: solid 0.05rem #EEE;}
  .inviter-order-lists .inviter-item .detail { min-height: 1.8rem; margin: 0 5rem 0 0; font-size: 0.55rem; word-wrap:break-word; line-height: 0.9rem; color: #555;padding-left:.5rem}
  .inviter-order-lists .inviter-item .money { position: absolute; z-index: 1; top: 0.5rem; right: 0.5rem; height: 0.9rem; line-height: 0.9rem;}
  .inviter-order-lists .inviter-item .money.add { color: #f23030;}
  .inviter-order-lists .inviter-item .money.reduce { color: #36BC9B;}
  .inviter-order-lists .inviter-item .date { position: absolute; z-index: 1; bottom: 0.4rem; right: 0.5rem; height: 0.9rem; font-size: 0.5rem; line-height: 0.9rem; color: #999;}
  .inviter-order-lists .inviter-item .date .green{color:green}
  .inviter-order-lists .inviter-item .invalid .money.add {color: gray;}
  .inviters-item {
    padding:10px;
    display:flex;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
    border-bottom:1px solid #f3f3f3;
    .item-left {
      width:35%;
      height:100px;
      margin-right:10px;
      img {
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .item-right {
      width:65%;
      font-size: 12px;
          display: flex;
    flex-direction: column;
    justify-content: space-between;
      p {
        position: relative;
        line-height: 1;
      }
      .ellipsi {
        overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box; /*将对象作为弹性伸缩盒子模型显示。*/
       -webkit-line-clamp: 2; /*设置需要显示的行数*/
       -webkit-box-orient: vertical;
      }
      .num {
        color:red;
        font-size: 16px;
      }
      .f-s {
        display:flex;
        justify-content: space-between;
                line-height: 1;

      }
      img {
        width:14px;
        position: absolute;
        right:0px;
        top:50%;
        transform: translateY(-50%);
      }
    }
  }
    .m-title {
    padding:15px;
    border-bottom:1px solid #f3f3f3;
    background: #fff;
    font-size:20px;
    color:red;
    text-align: center;
  }
  .fxsp {
      padding:10px 15px 5px; font-size:14px;background:#fff;
  }
  .fxgx {
    padding:10px 15px 10px; font-size:14px;background:#fff;border-bottom:1px solid #f3f3f3;
  }
</style>
